import { ASSESSMENT_URL } from "@/components/ResourceNotice";

export const SECTIONS = [
  { id: "rate", n: 1, label: "Rate", title: "Rate Yourself", color: "#E4572E", text: "Read each of the 25 topics and choose the statement that fits you best right now." },
  { id: "score", n: 2, label: "Score", title: "Score Yourself", color: "#F2A541", text: "Turn your choices into points and add up your Body, Mind, Spirit, Self and Others totals." },
  { id: "color", n: 3, label: "Color", title: "Color Your Flower", color: "#14A38B", text: "Shade each petal up to your score to see your own heat map at a glance." },
  { id: "grow", n: 4, label: "Grow", title: "Grow & Track", color: "#1F4266", text: "Choose a focus, write your plan, track each day for three months, then plan your next step." },
];

const Tab = ({ section, recto }) => {
  const i = SECTIONS.findIndex((s) => s.id === section);
  if (i < 0) return null;
  const s = SECTIONS[i];
  return (
    <div
      className="pk-tab absolute flex items-center justify-center"
      style={{ top: `${1.4 + i * 2.1}in`, height: "1.9in", width: "0.38in", background: s.color, [recto ? "right" : "left"]: 0 }}
      data-testid={`pk-tab-${s.id}`}
    >
      <span className="whitespace-nowrap text-[10px] font-bold uppercase tracking-[0.2em] text-white" style={{ transform: `rotate(${recto ? 90 : -90}deg)` }}>
        {s.n} · {s.label}
      </span>
    </div>
  );
};

export const PackPage = ({ n, total, section, children, plain = false, testId }) => {
  const recto = n % 2 === 1;
  const pad = recto ? { paddingLeft: "0.85in", paddingRight: "0.8in" } : { paddingLeft: "0.8in", paddingRight: "0.85in" };
  return (
    <div className="pk-page relative overflow-hidden bg-white" style={{ ...pad, paddingTop: "0.55in", paddingBottom: "0.8in" }} data-testid={testId || `pk-page-${n}`}>
      <Tab section={section} recto={recto} />
      <div className="h-full">{children}</div>
      {!plain && (
        <div
          className={`absolute bottom-[0.35in] flex items-center gap-2 text-[8pt] text-slate-500 ${recto ? "flex-row-reverse text-right" : ""}`}
          style={recto ? { right: "0.8in", left: "0.85in" } : { left: "0.8in", right: "0.85in" }}
        >
          <span className="font-semibold text-slate-700">Page {n} of {total}</span>
          <span className="flex-1" />
          <img src="/flower-logo.png" alt="" className="h-3.5 w-3.5" />
          <span>Minister's Helper LLC · www.MinistersHelper.com · For licensed use only</span>
        </div>
      )}
    </div>
  );
};

export const SectionCover = ({ id }) => {
  const s = SECTIONS.find((x) => x.id === id);
  return (
    <div className="flex h-full flex-col justify-center" data-testid={`pk-section-cover-${id}`}>
      <div className="font-mono text-sm uppercase tracking-[0.3em]" style={{ color: s.color }}>Section {s.n}</div>
      <h2 className="mt-3 font-display text-5xl font-bold tracking-tight text-slate-900">{s.title}</h2>
      <div className="mt-6 h-2 w-24 rounded-full" style={{ background: s.color }} />
      <p className="mt-6 max-w-md text-lg leading-relaxed text-slate-600">{s.text}</p>
    </div>
  );
};

export const PackCover = ({ title, subtitle }) => (
  <div className="flex h-full flex-col" data-testid="pk-cover">
    <div className="flex items-center gap-3">
      <img src="/flower-logo.png" alt="" className="h-10 w-10" />
      <span className="font-display text-lg font-semibold text-[#1F4266]">Minister's Helper</span>
    </div>
    <div className="flex flex-1 flex-col items-center justify-center text-center">
      <img src="/flower-logo.png" alt="" className="h-64 w-64" />
      <h1 className="mt-10 font-display text-5xl font-bold tracking-tight text-slate-900">{title}</h1>
      <p className="mt-4 text-lg text-slate-600">{subtitle}</p>
      <div className="mt-8 flex gap-2">
        {SECTIONS.map((s) => (
          <span key={s.id} className="rounded-full px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-white" style={{ background: s.color }}>{s.label}</span>
        ))}
      </div>
      <div className="mt-12 w-80 border-b border-slate-400 pb-1 text-left text-sm text-slate-500">Name:</div>
      <div className="mt-6 w-80 border-b border-slate-400 pb-1 text-left text-sm text-slate-500">Start date:</div>
    </div>
    <p className="text-center text-xs text-slate-500">Online version of the assessment: {ASSESSMENT_URL}</p>
  </div>
);
